import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 
    "depositCheckbox", "depositAmountField",
    "teachSafeFields", "teachSafeCheckbox", "testResult", "testScenario",
    "zubieFields", "zubieCheckbox", "zubieTestResult",
    "improvFields", "improvCheckbox"
  ]

  connect() {
    // Only run if elements exist (to avoid errors if only part of the settings page is rendered)
    // Each controller instance only sees targets within its own scope
    if (this.hasTeachSafeCheckboxTarget && this.hasTeachSafeFieldsTarget) {
      this.toggleTeachSafe()
    }
    if (this.hasZubieCheckboxTarget && this.hasZubieFieldsTarget) {
      this.toggleZubie()
    }
    if (this.hasImprovCheckboxTarget && this.hasImprovFieldsTarget) {
      this.toggleImprov()
    }
  }

  toggleDepositAmount() {
    const checkbox = this.depositCheckboxTarget;
    const amountField = this.depositAmountFieldTarget;
    
    if (checkbox.checked) {
      amountField.style.display = 'block';
    } else {
      amountField.style.display = 'none';
    }
  }

  toggleTeachSafe() {
    if (this.teachSafeCheckboxTarget.checked) {
      this.teachSafeFieldsTarget.style.display = "block"
    } else {
      this.teachSafeFieldsTarget.style.display = "none"
    }
  }

  toggleZubie() {
    if (this.zubieCheckboxTarget.checked) {
      this.zubieFieldsTarget.style.display = "block"
    } else {
      this.zubieFieldsTarget.style.display = "none"
    }
  }

  toggleImprov() {
    if (this.improvCheckboxTarget.checked) {
      this.improvFieldsTarget.style.display = "block"
    } else {
      this.improvFieldsTarget.style.display = "none"
    }
  }

  testConnection(event) {
    event.preventDefault()
    const resultTarget = this.testResultTarget
    resultTarget.textContent = "Testing..."
    resultTarget.className = "ml2 u-textSmall u-textMuted"

    // Note: Since the API key might be changed in the input but not saved, 
    // this test relies on the *saved* configuration in the backend. 
    // We could improve this by sending the form values, but for V1 using saved values is safer.
    
    fetch('/schools/setup/teach_safe/test_connection', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        resultTarget.textContent = data.message
        resultTarget.className = "ml2 u-textSmall u-textGreen"
      } else {
        resultTarget.textContent = data.message
        resultTarget.className = "ml2 u-textSmall u-textRed"
      }
    })
    .catch(error => {
      resultTarget.textContent = "Error testing connection."
      resultTarget.className = "ml2 u-textSmall u-textRed"
    })
  }

  testRegisterStudent(event) {
    event.preventDefault()
    const resultTarget = this.testResultTarget
    const scenario = this.testScenarioTarget ? this.testScenarioTarget.value : 'blank_fields'
    resultTarget.textContent = `Testing registration (Scenario: ${scenario})...`
    resultTarget.className = "ml2 u-textSmall u-textMuted"
    
    fetch('/schools/setup/teach_safe/test_registration', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ scenario: scenario })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        resultTarget.textContent = `${data.message} (Scenario: ${data.scenario})`
        resultTarget.className = "ml2 u-textSmall u-textGreen"
      } else {
        resultTarget.textContent = `${data.message} (Scenario: ${data.scenario})`
        resultTarget.className = "ml2 u-textSmall u-textRed"
      }
    })
    .catch(error => {
      resultTarget.textContent = "Error testing registration."
      resultTarget.className = "ml2 u-textSmall u-textRed"
    })
  }

  testZubieWebhook(event) {
    event.preventDefault()
    const resultTarget = this.zubieTestResultTarget
    const eventType = event.currentTarget.dataset.eventType
    resultTarget.textContent = `Testing ${eventType}...`
    resultTarget.className = "ml2 u-textSmall u-textMuted"
    
    fetch('/schools/setup/zubie/test_webhook', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ event_type: eventType })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        resultTarget.textContent = data.message
        resultTarget.className = "ml2 u-textSmall u-textGreen"
      } else {
        resultTarget.textContent = data.message
        resultTarget.className = "ml2 u-textSmall u-textRed"
      }
    })
    .catch(error => {
      resultTarget.textContent = "Error testing webhook."
      resultTarget.className = "ml2 u-textSmall u-textRed"
    })
  }

}
